import { Grid } from '@vapor/material'
import { BillF, DepositF, ReservationBillDocumentF, ReservationF } from '../../types/reservation-detail.types'
import Bills from './bills/bills'
import Deposits from './deposits/deposits'
import Billing from './billing/billing'
import { useMemo, useState } from 'react'

export type BillsTabProps = {
  readOnly: boolean
  propertyId: string
  reservation: ReservationF
  reservedResourceId: string | null
  bills: BillF[]
  deposits: DepositF[]
}

export function BillsTab({ readOnly, propertyId, reservation, reservedResourceId, bills, deposits }: BillsTabProps) {
  const [selectedDepositIds, setSelectedDepositIds] = useState<string[]>([])

  const documents = useMemo(() => {
    const uniqueIdDocumnts: ReservationBillDocumentF[] = []
    bills
      .filter((bill) => Boolean(bill.document))
      .map((b) => {
        if (uniqueIdDocumnts.findIndex((x) => x.id === b.document?.id) < 0) uniqueIdDocumnts.push(b.document as ReservationBillDocumentF)
        if (b.document?.creditNote && uniqueIdDocumnts.findIndex((x) => x.id === b.document?.creditNote?.id) < 0) uniqueIdDocumnts.push(b.document?.creditNote as ReservationBillDocumentF)
      })
    return uniqueIdDocumnts
  }, [bills])
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Bills {...{ propertyId, reservation, reservedResourceId, bills, deposits }} readOnly={readOnly} selectedDepositIds={selectedDepositIds} />
      </Grid>

      <Grid item xs={12}>
        <Deposits
          {...{ propertyId, reservation, deposits }}
          readOnly={readOnly}
          selectedDepositIds={selectedDepositIds}
          setSelectedDepositIds={(depositIds) => {
            setSelectedDepositIds(depositIds)
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Billing propertyId={propertyId} documents={documents} readOnly={readOnly} />
      </Grid>
    </Grid>
  )
}
